<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Payments <span v-if="client">&ndash; {{ client.name }}</span></h1>
      </div>
    </div>
    <div class="container-fluid">
      <payment-list-filters v-if="$userIsAdmin"
      :apply-filters="handleApplyFiltersCallback">
        <ladda-button
          slot="button"
          :click="handleApplyFiltersCallback"
          type="submit"
          class="btn btn-primary pull-right">
          Search
        </ladda-button>
      </payment-list-filters>

      <div class="dashboard-block">
        <pickstar-loading v-if="fetchingPayments" class="m-t-lg"/>

        <template v-else>
          <no-results v-if="haveNoPayments">
            <div>There are no payments.</div>

            <button v-if="haveAppliedFilters && $userIsNotClient" @click="handleResetFiltersCallback" class="btn btn-default btn-sm m-t-sm">Reset Filters</button>
          </no-results>

          <ul class="item-detail item-detail-payment list-links">
            <payment-list-item
              v-for="payment in payments"
              :key="payment.id"
              :payment="payment"/>
          </ul>

          <lazy-loading
            class="text-center"
            :loading="loading"
            :reached-bottom="handleGetNextPaymentCallback"
            ref="lazyLoading">
            <pickstar-loading slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { appliesFilters, handleServerErrors, fetchResourceScope } from 'mixins'
import PaymentListFilters from './PaymentListFilters'
import PaymentListItem from './PaymentListItem'
import LazyLoading from 'codium-lazy-loading'

export default {
  mixins: [fetchResourceScope, appliesFilters, handleServerErrors],

  components: {
    PaymentListFilters,
    PaymentListItem,
    LazyLoading
  },

  data () {
    return {
      fetchingPayments: false
    }
  },

  watch: {
    '$route': {
      handler () {
        this.handleGetPaymentsCallback()
      }
    }
  },

  created () {
    if (this.$userIsClient) {
      this.setFilter({ filter: 'status', value: [] })
    }
    this.handleGetPaymentsCallback()
  },

  computed: {
    ...mapState('payment', ['payments', 'filters', 'pagination']),
    ...mapGetters('payment', ['initialFiltersState']),
    ...mapState('app', ['loading']),

    /**
     * Determine if we have no payments.
     *
     * @return bool
     */
    haveNoPayments () {
      return this.payments.length === 0
    }
  },

  methods: {
    ...mapActions('payment', ['getPayments', 'getNextPayments', 'resetFilters', 'setFilter']),

    /**
     * Handle getting payments.
     *
     * @return Promise
     */
    handleGetPaymentsCallback () {
      if (this.fetchingPayments) {
        return Promise.resolve()
      }

      this.fetchingPayments = true

      return this.getPayments(this.queryParams)
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingPayments = false
        })
    },

    /**
     * Get the next set of payments with the query param filters.
     *
     * @return Promise
     */
    handleGetNextPaymentCallback () {
      return this.getNextPayments(this.queryParams)
        .catch(this.handleServerErrorsCallback)
    }
  }
}
</script>
